import { IGameState, INIT_GAME_STATE, INIT_TABLE_STATE, INIT_TOURNAMENT, IStrippedGameState, ITableState, ITournamentState, TableType } from '@soposopo/sopo-models';
import { ChatMessage } from '../club/club.state';

// export interface ComponentToLoad {
//     componentType: 'game' | 'stream' | 'scores';
//     gameStateId: GameStateId;
// }

export type ComponentToLoad = StreamToLoad | GameToLoad | ClubChatToLoad;


export interface ClubChatToLoad {
    componentType: 'clubChat';
    gameStateId: GameStateId;
}
export interface StreamToLoad {
    componentType: 'stream';
    gameStateId: GameStateId;
    gameToPreviewId: GameStateId;
}

export interface GameToLoad {
    componentType: 'game';
    gameStateId: GameStateId;
    tableId: string;
    tournamentId: string | undefined;
    type: TableType;
    clubId: string;
    toNav?: boolean;
    tableName?: string;
    tournamentName?: string;
    settings?: GameSettings;
    configId?: string;
}

export interface GameSettings {
    toBeSeated?: boolean;
    seatId?: number;
}

export type GameStateId = string;
export type GamesObjectType = {[key: string]: Game};

export interface GameState {
    games: GamesObjectType
    // otherComponentsNumber: number;
    gamesList: ComponentToLoad[];
    selectedGame: GameStateId;
    gridView: boolean;
    timebankCount: number;
}

export interface Game {
    dealer: IGameState;
    table: ITableState;
    players: any;
    fetching: boolean;
    error?: any;
    tournament: ITournamentState;
    messages: TableMessage[];
    unreadMessageCount: number;
    tableBottomAreaImage: string | null;
}

export const GAME_INIT: Game = {
    fetching: false,
    dealer: INIT_GAME_STATE,
    players: null,
    table: INIT_TABLE_STATE,
    tournament: INIT_TOURNAMENT,
    messages: [],
    unreadMessageCount: 0,
    tableBottomAreaImage: null,
}

export const GAME_INIT_STATE: GameState = {
    games: {},
    gamesList: [],
    selectedGame: '',
    gridView: false,
    timebankCount: 0,
};

export type CommonGameActionProps = {
    game: IStrippedGameState | IGameState;
    playerId: string;
    gameStateId: GameStateId;
}

export interface TableMessage extends ChatMessage {};

export { IGameState as Dealer } from '@soposopo/sopo-models';
